import { css } from 'emotion';

import { colors, fonts } from '../../../../styles';

const contentWrapper = css`
  margin: 0 20px 15px;
  display: flex;
  flex-direction: column;

  > img {
    display: block;
    height: 208px;
    margin: 34px auto;
  }
`;

const descriptionTitle = css`
  font-size: ${fonts.size.medium};
  font-weight: ${fonts.weight.medium};
`;

const iconTextWrapper = css`
  display: flex;
  flex-direction: column;
  margin-top: 15px;
  gap: 27.5px;
`;

const badge = css`
  display: flex;
  border-radius: 3px;
  padding: 0 16px;
  margin: 20px 0;
  align-items: center;
  color: ${colors.gray.dark};
  background-color: ${colors.shadows.getShadow(colors.gray.lightest, 0.5)};
`;

const buttonFAQ = css`
  text-decoration: none;
  margin-left: 5px;
`;

export default {
  contentWrapper,
  descriptionTitle,
  iconTextWrapper,
  badge,
  buttonFAQ,
};
